import pinnedApi from "./pinnedApi";
import { Dispatch } from "redux/commonTypes";
import { actionTypes } from "./pinnedTypes";
import { userPreviewType } from "../users/usersTypes";
import { ageFormatter } from "utils/helpers";
import { mainPhotoCropNormal } from "utils/helpers/cropPhoto";

const Actions = {
  setPinnedIds: (ids: Array<string>) => ({
    type: actionTypes.SET_PINNED_IDS,
    payload: ids,
  }),
  resetPinned: () => ({
    type: actionTypes.RESET_PINNED,
  }),
  getPinnedIds: (idCountry?: number | null) => (dispatch: Dispatch) => {
    dispatch(Actions.resetPinned());
    pinnedApi.getPinnedIds(idCountry)
    .then((resp) => {
      dispatch(Actions.setPinnedIds(resp.data.pinnedUsers || []));
    }).catch(() => {
      dispatch(Actions.setPinnedIds([]));
    }).finally(() => {
      dispatch(Actions.setLoadingPinned(false));
    })
  },
  setPinnedUsers: (previews: Array<userPreviewType>) => {
    const formattedPreviews =
      Array.isArray(previews) &&
      previews.map((el) => {
        return {
          id: el.previewUser.previewUserInfo.id,
          name: el.previewUser.previewUserInfo.name,
          city: el.previewUser.previewUserInfo.city.name,
          age: ageFormatter(el.previewUser.previewUserInfo.birthday),
          photo: mainPhotoCropNormal(el.previewUser.mainPhoto),
          photoCounter: el.numberOfPhotos,
          isOnline: el.previewUser.onlineStatus?.online,
          country: el.previewUser.previewUserInfo.country?.name,
          mainPhotoVerifiedStatus: el.previewUser.mainPhotoVerifiedStatus
        };
      });
    return {
      type: actionTypes.SET_PINNED_USERS,
      payload: formattedPreviews,
    };
  },
  getPinnedUsers: (ids: Array<string>, step: number) => (
    dispatch: Dispatch
  ) => {
    const splicedIds = [...ids].splice(0, step);
    pinnedApi.getUsersPreviews(splicedIds)
      .then((resp) => {
        dispatch(Actions.setPinnedUsers(resp.data.searchPreviewUsers || []));
      }).catch(() => {
        dispatch(Actions.setPinnedUsers([]));
      })
    ;
  },
  setPinnedUsersByPage: (previews: Array<userPreviewType>) => {
    const formattedPreviews =
      Array.isArray(previews) &&
      previews.map((el) => {
        return {
          id: el.previewUser.previewUserInfo.id,
          name: el.previewUser.previewUserInfo.name,
          city: el.previewUser.previewUserInfo.city.name,
          age: ageFormatter(el.previewUser.previewUserInfo.birthday),
          photo: mainPhotoCropNormal(el.previewUser.mainPhoto),
          photoCounter: el.numberOfPhotos,
          isOnline: el.previewUser.onlineStatus?.online,
          country: el.previewUser.previewUserInfo.country?.name,
          mainPhotoVerifiedStatus: el.previewUser.mainPhotoVerifiedStatus
        };
      });
    return {
      type: actionTypes.SET_PINNED_USERS_BY_PAGE,
      payload: formattedPreviews,
    };
  },
  getPinnedUsersByPage: (ids: Array<string>, start: number, step: number) => (
    dispatch: Dispatch
  ) => {
    const splicedIds = [...ids].splice(start, step);
    pinnedApi
      .getUsersPreviews(splicedIds)
      .then((resp) =>
        dispatch(Actions.setPinnedUsersByPage(resp.data.searchPreviewUsers))
      ).catch(() => {});
  },
  setLoadingPinned: (status: boolean) => ({
    type: actionTypes.SET_PINNED_LOADING,
    payload: status,
  }),
};

export default Actions;
